<template>
    <div>
        <news-overview-categories :currentCategory="currentCategory"></news-overview-categories>
        <div class="newsList" v-if="currentCategory ==='news'">
            <div class="row teaser-all newsItems">
                <div class="col col-12">
                    <div style="display: flex; margin-left: -25px; flex-wrap: wrap;">
                        <div class="" v-for="detail in displayNews" style="box-sizing: border-box; background-clip: padding-box; width: 33.3333%; border-width: 0px 0px 0px 25px; border-style: solid; border-color: transparent; border-image: initial; margin-bottom: 2rem;">
                            <news-detail 
                                :detail="detail"
                                :read_more_text="dictionary['SUCHE_Gesundheitsthemen_LinkText']"
                                :emitreadmore="emitNews"
                            ></news-detail>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col col-12 ctn-more">
                <more-button :total="totalResults??0" :elements="displayNews.length" :element="{}" :emit="'loadMoreNews'"></more-button>
            </div>
        </div>
    </div>
    <div class="newsList facebook" v-if="currentCategory ==='facebook'" v-html="iframeFacebook"></div>
    <div class="newsList instagram" v-if="currentCategory ==='instagram'" v-html="iframeInstagram"></div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { useNewsOverview } from './composables/UseNewsOverview';
import NewsOverviewCategories from './news-overview-categories.vue';
import { emitterInstance } from '@/classes/emitter';
import MoreButton from '../content-search/searchOverlay/more-button.vue';
import NewsDetail from './news-detail.vue';

const dictionary = {
        'SUCHE_Gesundheitsthemen_LinkText': 'Weiterlesen',
    }
const emitNews = "newsDetailReadMore"
const {
    currentCategory,
    displayNews,
    totalResults,
    iframeFacebook,
    iframeInstagram,
    initNews,
    loadMore,
    setCategory,
    setSearchHistory,
} = useNewsOverview();

onMounted(async ()=> {
    await initNews();

    emitterInstance.on("loadMoreNews", async()=>{
        await loadMore();
    })    
    emitterInstance.on("changeCategory", (category:any)=>{
         setCategory(category as string);
    })
    emitterInstance.on(emitNews, async(resultElement) =>{
           openResultUrl(resultElement as {key:string, url:string});      
        })
});
function openResultUrl(urlItem:{key:string, url:string}){  
    setSearchHistory(urlItem.key)      
    window.location.href = urlItem.url;
}
    

</script>